export const SELLING_COUNTRIES = ["US", "AU", "CA", "GB", "NZ"];

export const COUNTRY_CURRENCY = {
  US: "usd",
  AU: "aud",
  CA: "cad",
  GB: "gbp",
  NZ: "nzd",
};

export const COUNTRY_LABELS = {
  US: "United States",
  AU: "Australia",
  CA: "Canada",
  GB: "United Kingdom",
  NZ: "New Zealand",
};

export const COUNTRY_ALIASES = { UK: "GB" };

export const TAX_INCLUSIVE = true;
export const BILLING_INTERVAL = "month";

export function canonicalizeCountryCode(raw) {
  if (typeof raw !== "string") {
    return null;
  }
  let code = raw.trim().toUpperCase();
  if (!code) {
    return null;
  }
  code = COUNTRY_ALIASES[code] || code;
  if (!/^[A-Z]{2}$/.test(code)) {
    return null;
  }
  return code;
}

export function isSellingCountry(raw) {
  const code = canonicalizeCountryCode(raw);
  return code !== null && SELLING_COUNTRIES.includes(code);
}

export function currencyForCountry(raw) {
  const code = canonicalizeCountryCode(raw);
  if (code === null || !SELLING_COUNTRIES.includes(code)) {
    return null;
  }
  return COUNTRY_CURRENCY[code];
}

export function sellingCountryOrNull(raw) {
  const code = canonicalizeCountryCode(raw);
  if (code === null || !SELLING_COUNTRIES.includes(code)) {
    return null;
  }
  return code;
}

export const FALLBACK_SELLING_COUNTRY = "US";

export function resolveSellingCountry(raw) {
  return sellingCountryOrNull(raw) || FALLBACK_SELLING_COUNTRY;
}

export function sellingCountryOptions() {
  return SELLING_COUNTRIES.map((code) => ({
    code,
    label: COUNTRY_LABELS[code],
    currency: COUNTRY_CURRENCY[code],
  }));
}

export function majorToMinor(major) {
  if (major === "" || major === null || major === undefined) {
    return null;
  }
  const n = typeof major === "number" ? major : Number(String(major).trim());
  if (!Number.isFinite(n) || n < 0) {
    return null;
  }
  return Math.round(n * 100);
}

export function minorToMajor(minor) {
  const n = Number(minor);
  if (!Number.isFinite(n)) {
    return "";
  }
  return n / 100;
}

export function formatMinorAmount(amountMinor, currency) {
  const code = String(currency).toUpperCase();
  const digits = Number(amountMinor) % 100 === 0 ? 0 : 2;
  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: code,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(amountMinor) / 100);
  return `${formatted} / month`;
}
